import { Button } from '@/components/form/baseInputs/Button';
import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import { useTrackUserEvent } from '@/hooks/useTrackUserEvent';
import { ROUTE_KEYS } from '@/navigation/constants';

interface UseImprovedSummaryPageAnnouncementProps {
  onClose: () => void;
  householdId: string;
}

export function useImprovedSummaryPageAnnouncement({
  onClose,
  householdId,
}: UseImprovedSummaryPageAnnouncementProps) {
  const { navigate } = useNavigateToRoute();
  const trackUserEvent = useTrackUserEvent();

  const handleTryItOut = async () => {
    // The waterfall entry route selects an available waterfall and opens its summary.
    await navigate(ROUTE_KEYS.HOUSEHOLD_DETAILS_ESTATE_WATERFALL_TAB, {
      householdId,
    });
    trackUserEvent('waterfall summary_announcement_try_clicked', {
      householdId,
    });
    onClose();
  };

  return {
    heading: 'Improved summary page',
    imageUrl: 'improved-summary-page-announcement.png',
    imageAlt:
      'Waterfall summary overview and a separate death event page with beneficiary distributions and taxes.',
    bodyText:
      'The waterfall summary now gives each death event its own page, so every entity, beneficiary, and tax line is visible at a readable size.',
    actionButtons: (
      <Button variant="primary" size="sm" onClick={handleTryItOut}>
        Try it out
      </Button>
    ),
  };
}
